export enum LOGIN_FORM_TYPE {
  LOGIN = "LOGIN",
  REGISTER = "REGISTER",
  CODE = "CODE",
  PASSWORD_FORGOTTEN = "PASSWORD_FORGOTTEN",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
}
